import React from "react";
import BackTo from "../components/BackTo";
import HeroImage from "../media/projects/react-weather-app/react-weather-app_web-mock.png";

function ReactWeather() {
  return (
    <div className="project-page">
      <section className="project-main mb-5">
        <div className="container-fluid">
          <img
            src={HeroImage}
            alt="Cover of React Weather App subpage"
            className="project-main-image img-fluid mt-5"
          />

          <div className="row mt-5">
            <div className="col-sm-6">
              <h3 className="project-title">
                Weather App
                <br />
                (React.js)
              </h3>
              <p className="project-tag">HTML | CSS | React.js | AJAX</p>
            </div>

            <div className="col-sm-6">
              <p className="project-description">
                <span className="fw-bold">SheCodes React </span>is a 8-week
                part-time course that I attended, from March to April 2022.
                During the course, I learnt about the fundamentals of React — an
                in-demand Javascript framework — as well as how it makes web
                applications or websites easier to build and maintain, as
                compared to using VanillaJS.
                <br />
                <br />
                I built this second version of the weather app, as one of my
                graduating final projects for the course.
                <br />
                <br />
                <span className="fw-bold">Languages: </span>HTML5, CSS, and
                Javascript
                <br />
                <span className="fw-bold">Libraries / Frameworks: </span>React,
                Node.js, Bootstrap
                <br />
                <span className="fw-bold">API: </span>
                <a
                  href="https://openweathermap.org/api"
                  target="_blank"
                  rel="noreferrer"
                  title="Link to weather API"
                  className="portfolio-link"
                >
                  OpenWeather
                </a>
              </p>
              <br />
              <a
                href="https://astounding-sunshine-1dc12c.netlify.app"
                target="_blank"
                rel="noreferrer"
                title="Link to React Weather App"
                className="project-button text-decoration-none fw-bold"
              >
                Give the app a try!
              </a>
            </div>
          </div>
        </div>
      </section>

      <BackTo />
    </div>
  );
}

export default ReactWeather;
